<!-- 上传文书 -->
<template>
  <div>
    <!-- 上传文书第一步上传 -->
    <zlr-modal v-model="firstShow">
      <div class="essay-modify-first-upload">
        <h1>Upload</h1>
        <p>Please Note: You can only upload document ONCE for a round of editing.</p>
        <ul>
          <li>University: {{detail.projectUniver}}</li>
          <li>Program:{{detail.projectName}}</li>
          <li>PS / Essay: {{detail.title}}</li>
          <li>Mentee: {{detail.menteeName}}</li>
        </ul>
        <!--  red -->
        <div class="essay-modify-first-upload-con">
          <div class="essay-modify-first-noupload">
            <upload v-model="formValidate.url"
                    :format="['doc','docx']"
                    :path="`material/essay/${new Date().getTime()}`"
                    @on-success='upSuccess'>
              <div class="essay-modify-first-upload-prompt orange">
                Please note: Only “.doc” / “.docx” files can be uploaded.
              </div>
            </upload>
          </div>
        </div>
        <div class="essay-modify-first-upload-btn">
          <Button class="zlr-btn-default"
                  @click="firstShow = false">Close</Button>
          <div style="display:inline-block"
               :class="{'zlr-cover':!formValidate.url}">
            <Button class="next-btn zlr-btn-primary"
                    @click="nextHandle">Next</Button>
          </div>
        </div>
      </div>
    </zlr-modal>
    <!-- 上传文书第二步预览 -->
    <zlr-modal v-model="secondShow">
      <div class="essay-modify-second-upload">
        <h1>Preview</h1>
        <preview-iframe :file="file"
                        ref="preview"></preview-iframe>
        <div class="essay-modify-second-upload-prompt">Please Note: The format of the document content in Preview might be slightly different from in Microsoft Word, please only make sure the content itself is correct!</div>
        <div class="essay-modify-first-upload-btn">
          <Button class="zlr-btn-default"
                  @click="secondShow = false">Close</Button>
          <span>
            <Button class="next-btn zlr-btn-primary"
                    @click="secondHandle">Next</Button>
          </span>
        </div>
      </div>
    </zlr-modal>
    <!-- 填写feedback -->
    <zlr-modal v-model="feedbackShow">
      <div class="essay-modify-feedback">
        <h1>Feedback</h1>
        <div class="essay-modify-feedback-editor">
          <editor ref="analysisEditor"
                  :cache=false
                  v-model="formValidate.steer"></editor>
        </div>
        <h2>Time spent</h2>
        <div class="essay-modify-feedback-prompt">Your time will not be remunerated if it exceeds the maximum allowance of a module.</div>
        <ul class="essay-modify-feedback-ul">
          <li>
            <div>Number of Program</div>
            <div>{{schedule.projectCount}}</div>
          </li>
          <li>
            <div>Number of PS / Essay</div>
            <div>{{schedule.essayCount}}</div>
          </li>
          <li>
            <div>Number of SM editing rounds</div>
            <div v-if="userRole ==='SM'">{{schedule.essaySMRound}}</div>
            <div v-if="userRole ==='EM'">{{schedule.essayEMRound}}</div>
          </li>
        </ul>
        <ul class="essay-modify-feedback-ul">
          <template v-if="userRole ==='SM'">
            <li>
              <div>Module 4 (Max time)</div>
              <div>{{schedule.schedule.editEssayMax}} mins</div>
            </li>
            <li>
              <div>Module 4 (Remaining time)</div>
              <div>{{Number(schedule.schedule.editEssayMax) - Number(schedule.schedule.editEssayUsed)}} mins</div>
            </li>
          </template>
          <li>
            <div>Module 4 (Used time)</div>
            <div>{{schedule.schedule.editEssayUsed}} mins</div>
          </li>
        </ul>
        <Form ref="formValidate"
              :model="formValidate"
              :rules="ruleValidate">
          <FormItem label=""
                    prop="timeSpent"
                    :class="[
                    (errorMsg || exceedNinetyMsg)?'':'essay-modify-error-msg']"
                    :show-message="errorMsg || exceedNinetyMsg">
            <Input v-model="formValidate.timeSpent"
                   placeholder="Please fill out positive integer number of minutes"
                   @on-change="handleSendChange">
            <span slot="append">mins</span>
            </Input>
          </FormItem>
          <div class="essay-modify-error-msg-con"
               v-if="!errorMsg || !exceedNinetyMsg">
            <div v-if="!errorMsg">You have exceeded the maximum time allowance of a module, your exceeded time will not be remunerated！</div>
            <div v-if="!exceedNinetyMsg">The ZLR Mentor team will randomly check the editing quality of the essay. ZLR has the right to deduct the time spent to a reasonable number after evaluation if found the inconsistent between the time spent and editing quality. </div>
          </div>
        </Form>
        <div class="essay-modify-feedback-btn"
             :class="{
          'essay-modify-feedback-btn-add-dis': !errorMsg &&!exceedNinetyMsg
        }">
          <Button class="zlr-btn-default"
                  @click="feedbackShow = false">Close</Button>
          <span>
            <Button class="next-btn zlr-btn-primary"
                    @click="subHandle"
                    :loading="isSub">Confirm</Button>
          </span>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
// api
import { subUploadEssay, getViewDetail, getMaterialTimeSchedule } from '@/api/material'
// components
import ZlrModal from '_c/modal/modal'
import Upload from '_c/upload/upload'
import Editor from '_c/editor/editor'
// constant
import { promptInput, uploadSuc } from '@/constant'
import { validateNumber, isNum } from '@/libs/validator'
import { mapState } from 'vuex'
import PreviewIframe from './preview-iframe'
export default {
  name: 'program-essay-upload',
  props: ['upData'],
  components: {
    ZlrModal,
    Upload,
    Editor,
    PreviewIframe
  },
  data () {
    return {
      feedbackShow: false,
      detail: {},
      formValidate: {},
      ruleValidate: {
        timeSpent: [{ required: true, message: promptInput }, { validator: validateNumber }]
      },
      firstShow: false,
      secondShow: false,
      isSub: false,
      schedule: {
        schedule: {}
      },
      file: '',
      errorMsg: true,
      exceedNinetyMsg: true
    }
  },
  computed: {
    ...mapState({
      'userRole' (state) {
        return state.user.userRole
      }
    }),
    difference () {
      let num = Number(this.schedule.schedule.editEssayMax) - Number(this.schedule.schedule.editEssayUsed)
      return num < 0 ? 0 : num
    }
  },
  mounted () {
    this.getViewDetail()
  },
  methods: {
    // 获取详情
    getViewDetail () {
      if (!this.upData.id) {
        return false
      }
      getViewDetail({
        billId: this.upData.id,
        editType: this.upData.type
      }).then(res => {
        this.detail = res.data.model
      })
    },
    // 获取剩余时间
    getMaterialTimeSchedule () {
      getMaterialTimeSchedule({
        id: this.upData.jointId
      }).then(res => {
        this.schedule = res.data
      })
    },
    // 显示第一步
    showHandle () {
      this.resetData()
      this.firstShow = true
    },
    // 下一步
    nextHandle () {
      this.firstShow = false
      this.secondShow = true
      this.$nextTick(() => {
        this.$refs['preview'].getUrl()
      })
    },
    // 第二步
    secondHandle () {
      this.secondShow = false
      this.feedbackShow = true
      this.getMaterialTimeSchedule()
    },
    // 上传
    upSuccess (file) {
      this.file = file
      this.formValidate.fileName = file.name
    },
    // 提交
    subHandle () {
      if (!this.formValidate.steer) {
        this.$zlr_message('Please fill in the feedback', 'error')
        return false
      }
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          this.isSub = true
          data.id = this.upData.itemId
          subUploadEssay(data).then(() => {
            this.feedbackShow = false
            this.$zlr_message(uploadSuc, 'success')
            this.$emit('on-success')
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          }).then(() => {
            this.isSub = false
          })
        }
      })
    },
    // 重置数据
    resetData () {
      this.formValidate = {}
      if (this.$refs['analysisEditor']) {
        this.$refs['analysisEditor'].setHtml('')
      }
    },
    handleSendChange (value) {
      let data = value.target.value
      this.errorMsg = true
      this.exceedNinetyMsg = true
      if (!(this.userRole === 'SM' && isNum(data))) return false
      if (data > this.difference) { this.errorMsg = false }
      if (data >= 90) { this.exceedNinetyMsg = false }
    }
  },
  watch: {
    upData () {
      this.getViewDetail()
    }
  }
}
</script>
<style lang='less' scoped>
</style>
